import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFocusMagic: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="focus-magic"><path d="M3.75 8V3.75H8M3.75 16V20.25H8M16 3.75H20.25V8M20.25 16V20.25H16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.3333 9.33333L13.5 7L14.6667 9.33333L17 10.5L14.6667 11.6667L13.5 14L12.3333 11.6667L10 10.5L12.3333 9.33333Z" fill="currentColor"/><path d="M8.66667 13.6667L9.5 12L10.3333 13.6667L12 14.5L10.3333 15.3333L9.5 17L8.66667 15.3333L7 14.5L8.66667 13.6667Z" fill="currentColor"/></CentralIconBase>;
};

export default IconFocusMagic;
